import { render, staticRenderFns } from "./Vote.vue?vue&type=template&id=dd74db90&scoped=true&"
import script from "./Vote.vue?vue&type=script&lang=js&"
export * from "./Vote.vue?vue&type=script&lang=js&"
import style0 from "./Vote.vue?vue&type=style&index=0&id=dd74db90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd74db90",
  null
  
)

export default component.exports